"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _de = _interopRequireDefault(require("react-intl/locale-data/de"));

var _en = _interopRequireDefault(require("react-intl/locale-data/en"));

var _fr = _interopRequireDefault(require("react-intl/locale-data/fr"));

var _it = _interopRequireDefault(require("react-intl/locale-data/it"));

var _nl = _interopRequireDefault(require("react-intl/locale-data/nl"));

var _locales = _interopRequireDefault(require("../i18n/locales"));

(0, _reactIntl.addLocaleData)([].concat((0, _toConsumableArray2.default)(_de.default), (0, _toConsumableArray2.default)(_en.default), (0, _toConsumableArray2.default)(_fr.default), (0, _toConsumableArray2.default)(_it.default), (0, _toConsumableArray2.default)(_nl.default)));

var withI18n = function withI18n(Component) {
  var I18nProvider = function I18nProvider(props) {
    var locale = props.locale;
    return _react.default.createElement(_reactIntl.IntlProvider, {
      key: locale,
      locale: locale,
      messages: _locales.default[locale]
    }, _react.default.createElement(Component, props));
  };

  return I18nProvider;
};

var _default = withI18n;
exports.default = _default;